module.exports = __webpack_public_path__ + "static/media/lintas-arta-logo.203fab42.png";